import { render, staticRenderFns } from "./ToolsLayoutSection.vue?vue&type=template&id=4c08cca1&scoped=true&"
import script from "./ToolsLayoutSection.vue?vue&type=script&lang=js&"
export * from "./ToolsLayoutSection.vue?vue&type=script&lang=js&"
import style0 from "./ToolsLayoutSection.vue?vue&type=style&index=0&id=4c08cca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08cca1",
  null
  
)

export default component.exports